import { LEAVE_REQUEST_STATUSES } from '../constants/variables';
import httpClient from './httpClient';

export const leaveRequests = {
  getListLeaveRequests() {
    return httpClient.get('/api/adv/leave-requests');
  },
  getLeaveRequestsByMonth(pkAdv, start, end) {
    return httpClient.get(`/api/adv/leave-requests?pkAdv=${pkAdv}&start=${start}&end=${end}`);
  },
  getListLeaveRequestType() {
    return httpClient.get('/api/adv/leave-request/types');
  },
  getListLeaveRequestStatus() {
    return httpClient.get('/api/adv/leave-request/status');
  },
  createLeaveRequest(data) {
    return httpClient.post('/api/adv/leave-request', data)
  },
  updateLeaveRequest(data,pkLeaveRequest) {
    return httpClient.put(`/api/adv/leave-request/${pkLeaveRequest}`, data)
  },
  deletedLeaveRequest(pkLeaveRequest) {
    return httpClient.delete(`/api/adv/leave-request/${pkLeaveRequest}`)
  },
  cancelLeaveRequest(pkLeaveRequest) {
    return httpClient.put(`/api/adv/leave-request/cancellation/${pkLeaveRequest}`, { pkIxStatutDemande: LEAVE_REQUEST_STATUSES.VALIDATED_PENDING_CANCELLATION })
  },

  getRefuralReason() {
    return httpClient.put(`/api/adv/leave-request/motif`)
  },
  getCounter() {
    return httpClient.get(`/api/adv/leave-request/solde`)
  }
}

export default leaveRequests;
